import { render, staticRenderFns } from "./faces.vue?vue&type=template&id=8e5b652a&scoped=true&"
import script from "./faces.vue?vue&type=script&lang=js&"
export * from "./faces.vue?vue&type=script&lang=js&"
import style0 from "./faces.vue?vue&type=style&index=0&id=8e5b652a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5b652a",
  null
  
)

export default component.exports